<template>
  <DashboardCardTitle class="mb-4">
    <template #icon
      ><v-img alt="Debt Solutions Icon" height="40" width="55" :src="debtSolutionsIcon"
    /></template>
    <template #title
      ><h2 :class="$vuetify.display.xs ? 'text-h2 mt-1' : 'text-h1'">
        {{ $t('L_debt_solutions') }}
      </h2></template
    >
  </DashboardCardTitle>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import DashboardCardTitle from '@/modules/home/dashboard/components/DashboardCardTitle.vue';
import debtSolutionsIcon from '@/assets/debt-solutions-icon.svg';

export default defineComponent({
  name: 'DebtSolutionsCardTitle',
  components: {
    DashboardCardTitle,
  },
  data() {
    return { debtSolutionsIcon };
  },
});
</script>
